import { extendTheme } from "@chakra-ui/react";

const REIVColor = "#00adee";

export const ReivThemeDefinition = {
  components: {
    Input: {
      defaultProps: {
        focusBorderColor: "brand.500",
      },
    },
    Textarea: {
      defaultProps: {
        focusBorderColor: "brand.500",
      },
    },
    Radio: {
      defaultProps: {
        colorScheme: "brand",
      },
    },
    Checkbox: {
      defaultProps: {
        colorScheme: "brand",
      },
    },
    Link: {
      variants: {
        primary: ({ colorScheme = "gray" }) => ({
          color: `${colorScheme}.900`,
          _hover: {
            color: `${colorScheme}.500`,
          },
          textDecoration: "underline",
        }),
      },
      defaultProps: {
        variant: "primary",
      },
    },
  },
  colors: {
    brand: {
      "50": "#E5F8FF",
      "100": "#f0f8ff",
      "200": "#8ADFFF",
      "300": "#5CD3FF",
      "400": "#2EC6FF",
      "500": REIVColor,
      "600": "#0095CC",
      "700": "#007099",
      "800": "#004A66",
      "900": "#002533",
    },
    primary: {
      "50": "#E5F8FF",
      "100": "#B8ECFF",
      "200": "#8ADFFF",
      "300": "#5CD3FF",
      "400": "#2EC6FF",
      "500": REIVColor,
      "600": "#0095CC",
      "700": "#007099",
      "800": "#004A66",
      "900": "#002533",
    },
    buttonPrimary: {
      "50": "#E5F8FF",
      "100": "#B8ECFF",
      "200": "#8ADFFF",
      "300": "#5CD3FF",
      "400": "#2EC6FF",
      "500": REIVColor,
      "600": "#0095CC",
      "700": "#007099",
      "800": "#004A66",
      "900": "#002533",
    },
    secondary: {
      50: "#F5F5F5",
      100: "#F5F5F5",
      200: "#C6C8CB",
      300: "#8D9298",
      400: "#737373",
      500: "#737373",
      600: "#737373",
      700: "#585858",
      800: "#272E35",
      900: "#212121",
    },
    buttonSecondary: {
      50: "#F5F5F5",
      100: "#F5F5F5",
      200: "#C6C8CB",
      300: "#8D9298",
      400: "#e2e3e4",
      500: "#F5F5F5",
      600: "#e2e3e4",
      700: "#e2e3e4",
      800: "#e2e3e4",
      900: "#e2e3e4",
    },
    neutral: {
      50: "#F5F5F5",
      100: "#F5F5F5",
      200: "#C6C8CB",
      300: "#8D9298",
      400: "#737373",
      500: "#737373",
      600: "#737373",
      700: "#585858",
      800: "#272E35",
      900: "#212121",
    },
  },
  fonts: {
    heading: "Open Sans,-apple-system,BlinkMacSystemFont,sans-serif",
    body: "Open Sans,-apple-system,BlinkMacSystemFont,sans-serif",
    mono: "Open Sans,-apple-system,BlinkMacSystemFont,sans-serif",
  },
};

export const ReivTheme = extendTheme(ReivThemeDefinition);
